import { ElectricalAspectItemComponentBase } from './electrical-aspect-item.component.base';
import { Component, ElementRef, Injector, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, positiveIntegerValidator, requiredValidator, UserStorage } from '@scisys-uim/uim-common';
import { Asset } from 'assets-model';
import { ElectricalAspectService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-electrical-aspect-item',
  templateUrl: './electrical-aspect-item.component.html',
  styleUrls: ['./electrical-aspect-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class ElectricalAspectItemComponent extends ElectricalAspectItemComponentBase {

  @Input()
  asset: Asset;

  constructor(protected electricalAspectService: ElectricalAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(electricalAspectService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  createForm(): FormGroup {
    return this.fb.group({
      aspectAssetId: [null, []],
      lockVersion: [null, []],
      portableApplianceTestingDays: [null, [requiredValidator, positiveIntegerValidator]]
    });
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  itemSet() {
    super.itemSet();
  }

}





